import type { CalculationContext } from '@/features/execute-calculation-set/overmind/calculation/actions';
import type { RoutingContext } from '@/overmind/effects/router';

import type { Context } from '../../../overmind';
import { routes } from '../../../overmind/machines/router';

export const handleTriggerCalculationSetExecutionRoute = (
  context: Context
) => ({
  [routes.executeCalculationSetUsing]: ({ params }: RoutingContext) => {
    context.actions.internal.setRoute({
      route: 'executeCalculationSetUsing',
      params
    });
    const calculationContext = params as CalculationContext | undefined;
    context.actions.calculation.initializeTriggeringCalculationSetExecution(
      calculationContext
    );
  }
});
